import apiClient from "./axios"

export const getComplaints = async (params = {}) => {
  const { data } = await apiClient.get("/complaints", { params })
  return data
}

export const getComplaintMeta = async () => {
  const { data } = await apiClient.get("/complaints/meta")
  return data
}

export const getComplaint = async id => {
  const { data } = await apiClient.get(`/complaints/${id}`)
  return data
}

export const updateComplaintStatus = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/complaints/${id}/status`, payload)
  return data
}
